import { styled } from "@mui/system";

export const Page = styled("div")({
  display: "flex",
  flexDirection: "column",
  width: "100%",
  paddingLeft: "60px",
  paddingTop: "60px",
});

export const Body = styled("div")(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  height: "100%",
  width: "100%",
  padding: "20px",
  gap: "20px",
}));

export const Header = styled("div")(({ theme }) => ({
  backgroundColor: "white",
  width: "100%",
  padding: "10px",
  boxShadow: "1px 4px 10px rgba(48, 111, 188, 0.2)",
}));

export const SubHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-start",
  gap: "10px",
  width: "100%",
  "& .MuiTextField-root": {
    marginLeft: 0,
  },
}));
